import React from 'react'
import { AUDIO, useAudio } from '../providers/AudioProvider';

const IconGlowWrapper = ({
    icon,
    className,
    onClick,
    color = "blue",
}: {
    icon: React.ReactNode;
    className?: string;
    onClick?: () => void;
    color?: "blue" | "yellow" | "red" | "black";
}) => {
    // Map color prop to actual color value
    const colorMap: Record<string, string> = {
        blue: '#3B82F6', // Tailwind blue-500
        yellow: '#EABD08', // Tailwind yellow-500
        red: '#EF4444', // Tailwind red-500
        black: '#000000',
    };
    const glowColor = colorMap[color] || colorMap.blue;
    const darkColorMap: Record<string, string> = {
        blue: '#1e40af',
        yellow: '#854d0e',
        red: '#991b1b',
        black: '#000000',
    };
    const darkColor = darkColorMap[color] || darkColorMap.yellow;
    const { play } = useAudio();

    return (
        <div
            className={`relative flex items-center text-3xl cursor-pointer ${className}`}
            onMouseEnter={() => onClick ? play(AUDIO.HOVER) : null}
            onClick={() => onClick ? (play(AUDIO.CLICK), onClick()) : null}
        >
            {/* Blurred icon behind */}
            <span
                className="absolute inset-0 blur-[2px] pointer-events-none scale-110"
                style={{ zIndex: 0, color: glowColor }}
            >
                {icon}
            </span>


            {/* Dark highlight icon behind */}
            <span
                className="absolute inset-0 blur-[1px] pointer-events-none scale-[1.05] translate-y-[-1px] opacity-70"
                style={{ zIndex: 0, color: darkColor }}
            >
                {icon}
            </span>
            <span
                className="absolute inset-0 blur-[1px] pointer-events-none scale-[1.05] translate-y-[1px] opacity-70"
                style={{ zIndex: 0, color: darkColor }}
            >
                {icon}
            </span>
            <span
                className="absolute inset-0 blur-[1px] pointer-events-none scale-[1.05] translate-x-[-1px] opacity-70"
                style={{ zIndex: 0, color: darkColor }}
            >
                {icon}
            </span>
            <span
                className="absolute inset-0 blur-[1px] pointer-events-none scale-[1.05] translate-x-[1px] opacity-70"
                style={{ zIndex: 0, color: darkColor }}
            >
                {icon}
            </span>


            {/* Blurred icon behind */}
            <span
                className="absolute inset-0 blur-[1px] pointer-events-none scale-80"
                style={{ zIndex: 0, color: glowColor }}
            >
                {icon}
            </span>
            {/* Main icon */}
            <span className="relative text-white" style={{ zIndex: 1 }}>
                {icon}
            </span>
        </div>
    )
}

export default IconGlowWrapper